module.exports = __webpack_public_path__ + "static/img/icon-tip-blue.eeb3be43.svg";